// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_2e82eNOe0o84r4Mu77sV9H","Dell":"FUPzXSxqO0_IVfV_FXK5g","Abbott":"DLtL_2Ut_OgJyfUZ-Qc_N","Gap":"_3udIIomHDIoHNvWkinOzLJ","Allstate":"PDU1CRFUQ6ketkqMjW2Zv","Asurion":"_3hHbNAJt3ke0sZlT8o1HGj","Invitae":"_6YjNBlDqft6QbOyjd_2cP","JWE":"_12jmxwald089AEgqLhsmUB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Themes/docs/theme.scss
// module id = 1wCz
// module chunks = 12